import { Logo } from 'app/shared/components';
import { useRemoveLoading } from 'app/shared/utils/removeLoading';
import React, { useState } from 'react';
import Completed from './Completed';
import Facebook from './Facebook';
import ActiveDirectory from './ActiveDirectory';
import { useStyles } from './styles';
import { surveyLoginType } from '../../../config/system';
import {
  Exception,
  ExceptionService,
} from 'app/core/status';
/**
 * Support `facebook` && `ad` for now.
 */
function ThirdPartyLogin() {
  const [isCompleted, setIsCompleted] = useState(false);
  const [notAllowed, setNotAllowed] = useState(false);
  const styles = useStyles();

  let thirdParties;
  const setException = ExceptionService.useSetException();

  if (surveyLoginType && surveyLoginType === 'facebook'){
    if (isCompleted) {
      thirdParties = <Completed />;
    } else {
      thirdParties = <Facebook setIsCompleted={setIsCompleted} />;
    }
  } else {
    if (isCompleted) {
      thirdParties = <Completed />;
    } else if (notAllowed) {
      setException(new Exception('NOT_ALLOWED'));
    } else {
      thirdParties = <ActiveDirectory setIsCompleted={setIsCompleted} setNotAllowed={setNotAllowed} />;
    }
  }

  useRemoveLoading();

  return (
    <div className={styles.thirdPartyLogin}>
      {surveyLoginType && surveyLoginType === 'facebook' && <Logo />}
      <div className={styles.thirdParties}>{thirdParties}</div>
    </div>
  );
}

export default ThirdPartyLogin;
